import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

export const setAlert = createAsyncThunk("alerts", async (data) => {
    const id = uuidv4();
    console.log({ ...data, id })
    return { ...data, id }
});